import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useGetSitesQuery } from "../../../features/sites/sitesApiSlice";

export default function SiteSelectField({ disabled, site, setSite }) {
  const { data: sites } = useGetSitesQuery();

  const handleChange = (event) => {
    setSite(event.target.value);
  };

  return (
    <div>
      <FormControl sx={{ minWidth: 180 }}>
        <InputLabel id="site-select-field-label">Standort</InputLabel>
        <Select
          labelId="site-select-field-label"
          id="site-select-field"
          value={site}
          label="Standort"
          onChange={handleChange}
          disabled={disabled}
        >
          {sites &&
            sites.map((s) => (
              <MenuItem key={s._id} value={s._id}>
                {s.siteName}
              </MenuItem>
            ))}
        </Select>
        <FormHelperText>Standort auswählen</FormHelperText>
      </FormControl>
    </div>
  );
}
